var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFastGrocery = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Food-Delivery-Rider--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Food Delivery Rider Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.22 24A2.93 2.93 0 0 0 22 21.8h-5.61a2.93 2.93 0 0 0 2.83 2.2Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72 24a2.93 2.93 0 0 0 2.83 -2.2H5.9A2.92 2.92 0 0 0 8.72 24Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.71 19a6.29 6.29 0 0 0 -5.36 -4.86v-1.27a1.88 1.88 0 0 0 1.31 0.54h1.47a0.5 0.5 0 0 0 0.5 -0.5V10a0.5 0.5 0 0 0 -0.5 -0.5h-1.47a1.88 1.88 0 0 0 -1.31 0.54V9.7A2.36 2.36 0 0 0 16 7.34h-0.53a0.75 0.75 0 0 0 0 1.5H16a0.86 0.86 0 0 1 0.86 0.86V19h-2.72a1 1 0 0 1 -0.06 -0.36 4.54 4.54 0 0 0 -0.77 -2.52h-9a4.85 4.85 0 0 0 -0.91 2.8v1.34a0.49 0.49 0 0 0 0.5 0.49h18.4a1.44 1.44 0 0 0 1.18 -0.61 1.41 1.41 0 0 0 0.26 -0.83 1.5 1.5 0 0 0 -0.03 -0.31Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85 12.18h5.04s1.14 0 1.14 1.14v0.18s0 1.14 -1.14 1.14H5.85s-1.14 0 -1.14 -1.14v-0.18s0 -1.14 1.14 -1.14",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.59 6.72a3.31 3.31 0 0 0 2.06 -3.24A3.13 3.13 0 0 0 2.84 0.12 3.13 3.13 0 0 0 0 3.48a3.32 3.32 0 0 0 2.09 3.24v3.37a0.76 0.76 0 0 0 0.75 0.75h0.05a0.9 0.9 0 0 0 0.32 -0.09 0.76 0.76 0 0 0 0.38 -0.66Zm-0.75 -1.37c-0.7 0 -1.3 -0.86 -1.3 -1.87s0.6 -1.86 1.3 -1.86 1.31 0.85 1.31 1.86 -0.6 1.87 -1.31 1.87Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9 6.74v3.35a0.75 0.75 0 0 0 1.21 0.59 0.77 0.77 0 0 0 0.29 -0.59V6.74a2.45 2.45 0 0 0 2.22 -2.21V0.87a0.75 0.75 0 1 0 -1.5 0v3.66c0 0.24 -0.29 0.51 -0.72 0.66V0.87a0.75 0.75 0 1 0 -1.5 0v4.32c-0.44 -0.15 -0.73 -0.42 -0.73 -0.66V0.87a0.75 0.75 0 1 0 -1.5 0v3.66A2.45 2.45 0 0 0 8.9 6.74Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFastGrocery);
export default ForwardRef;